import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { SiteContentProvider } from "./context/SiteContent";
import Layout from "./components/Layout";
import AnalyticsTracker from "./components/AnalyticsTracker";
import Home from "./pages/Home";
import About from "./pages/About";
import CurriculumVitae from "./pages/CurriculumVitae";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

function App() {
  return (
    <SiteContentProvider>
      <BrowserRouter>
        <AnalyticsTracker />
        <Routes>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/*" element={
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/cv" element={<CurriculumVitae />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<Terms />} />
                {/* Rogue / removed pages → permanent redirect to homepage */}
                <Route path="/food" element={<Navigate to="/" replace />} />
                <Route path="/home" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          } />
        </Routes>
      </BrowserRouter>
    </SiteContentProvider>
  );
}

export default App;
